import $ from 'jquery';
const { registerBlockType } = wp.blocks;
const {
  RichText,
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
  URLInputButton,
} = wp.blockEditor;
const { Button, Icon, PanelBody, SelectControl, ToggleControl } = wp.components;
const { Fragment, useEffect } = wp.element;
const { __ } = wp.i18n;
import horizontalSlider from '../../../resources/scripts/module/horizontal-slider';

const cornerClassMapping = {
  'section-dark-secondary': 'corner-dark-secondary',
  'section-dark-primary': 'corner-dark-primary',
  'section-light-primary': 'corner-light-primary',
  'section-light-secondary': 'corner-light-secondary',
};

import PgButton from '../utils/pg-button';

const BlockEdit = ({ attributes, setAttributes }) => {
  const {
    slides,
    uniqueSliderId,
    sectionTitle,
    description,
    sectionClass,
    cornerPositionClass,
    cornerBackgroundClass,
  } = attributes;

  if (!uniqueSliderId) {
    const newId = 'horizontal-slider-' + Math.floor(Math.random() * 1000);
    setAttributes({ uniqueSliderId: newId });
  }

  useEffect(() => {
    if (!uniqueSliderId || !slides.length) return;
    horizontalSlider();
  }, [slides.length, uniqueSliderId]);

  const addSlide = () => {
    const newSlides = [
      ...slides,
      {
        quote: '',
        nameTitle: '',
        logoUrl: '',
        logoAlt: '', // Add alt field for logo
        imgUrl: '',
        imgAlt: '', // Add alt field for image
        buttonUrl: '',
        buttons: [],
      },
    ];
    setAttributes({ slides: newSlides });
    const slider = $(`#${uniqueSliderId}`);
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  };

  const removeSlide = (index) => {
    const newSlides = slides.filter((_, i) => i !== index);
    setAttributes({ slides: newSlides });
    const slider = $(`#${uniqueSliderId}`);
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  };

  const updateSlide = (index, updates) => {
    const newSlides = slides.map((slide, i) =>
      i === index ? { ...slide, ...updates } : slide
    );
    setAttributes({ slides: newSlides });
    const slider = $(`#${uniqueSliderId}`);
    slider.trigger('updateTitle');
  };

  const addButtonToSlide = (slideIndex) => {
    const newButtons = [
      ...(slides[slideIndex].buttons || []),
      {
        link: '#',
        label: 'New Button',
        buttonClass: 'btn btn-light btn-outline',
        isDark: false,
      },
    ];
    updateSlide(slideIndex, { buttons: newButtons });
  };

  const removeButtonFromSlide = (slideIndex, buttonIndex) => {
    const newButtons = slides[slideIndex].buttons.filter(
      (_, i) => i !== buttonIndex
    );
    updateSlide(slideIndex, { buttons: newButtons });
  };

  const updateButtonInSlide = (slideIndex, buttonIndex, updates) => {
    const newButtons = slides[slideIndex].buttons.map((button, i) =>
      i === buttonIndex ? { ...button, ...updates } : button
    );
    updateSlide(slideIndex, { buttons: newButtons });
  };

  const getSlideContent = (slide, index) => (
    <div className="product-slide-container" key={index}>
      <div className="content">
        <div>
          <RichText
            tagName="h2"
            value={slide.quote}
            keepPlaceholderOnFocus={true}
            onChange={(quote) => updateSlide(index, { quote })}
            placeholder={__('Enter quote...')}
          />
          <div className="description">
            <RichText
              tagName="p"
              value={slide.nameTitle}
              keepPlaceholderOnFocus={true}
              onChange={(nameTitle) => updateSlide(index, { nameTitle })}
              placeholder={__('Enter name and title...')}
            />
          </div>
          <MediaUploadCheck>
            <MediaUpload
              onSelect={
                (media) =>
                  updateSlide(index, { logoUrl: media.url, logoAlt: media.alt }) // Capture alt for logo
              }
              allowedTypes={['image']}
              value={slide.logoUrl}
              render={({ open }) => (
                <Button
                  onClick={open}
                  isPrimary
                  isSmall
                  className={'addButton'}
                >
                  {slide.logoUrl ? (
                    <>
                      <Icon icon="edit" /> {__('Change Logo')}
                    </>
                  ) : (
                    <>
                      <Icon icon="format-image" /> {__('Add Logo')}
                    </>
                  )}
                </Button>
              )}
            />
          </MediaUploadCheck>
          {slide.logoUrl && (
            <Button
              isSmall
              isDestructive
              onClick={() => updateSlide(index, { logoUrl: '', logoAlt: '' })}
            >
              <Icon icon="trash" /> {__('Remove Logo')}
            </Button>
          )}
          {slide.logoUrl && (
            <div className={'logo'}>
              <img src={slide.logoUrl} alt={slide.logoAlt || 'Logo'} />
            </div>
          )}

          <div className="buttons">
            {slide.buttons &&
              slide.buttons.length &&
              slide.buttons.map((button, bIndex) => (
                <div key={`btnIdx-${bIndex}`}>
                  <PgButton
                    link={button.link}
                    label={button.label}
                    buttonClass={button.buttonClass}
                    onUpdate={(object) =>
                      updateButtonInSlide(index, bIndex, object)
                    }
                    onRemove={() => removeButtonFromSlide(index, bIndex)}
                    linkField={'link'}
                    labelField={'label'}
                    buttonClassField={'buttonClass'}
                  />
                </div>
              ))}
            <div className={'fullWidth'}>
              <Button
                isPrimary
                onClick={() => addButtonToSlide(index)}
                className={'clearfix'}
              >
                + {__('Add Button')}
              </Button>
            </div>
          </div>
        </div>
        <div>
          <MediaUploadCheck>
            <MediaUpload
              onSelect={
                (media) =>
                  updateSlide(index, { imgUrl: media.url, imgAlt: media.alt }) // Capture alt for image
              }
              allowedTypes={['image']}
              value={slide.imgUrl}
              render={({ open }) => (
                <Button
                  onClick={open}
                  isPrimary
                  isSmall
                  className={'addButton'}
                >
                  {slide.imgUrl ? (
                    <>
                      <Icon icon="edit" /> {__('Change Image')}
                    </>
                  ) : (
                    <>
                      <Icon icon="format-image" /> {__('Add Image')}
                    </>
                  )}
                </Button>
              )}
            />
          </MediaUploadCheck>
          {slide.imgUrl && (
            <Button
              isSmall
              isDestructive
              onClick={() => updateSlide(index, { imgUrl: '', imgAlt: '' })}
            >
              <Icon icon="trash" /> {__('Remove Image')}
            </Button>
          )}
          {slide.imgUrl && (
            <img src={slide.imgUrl} alt={slide.imgAlt || 'Image'} />
          )}{' '}
          {/* Display imgAlt */}
        </div>
      </div>
      <p className="button-corner">
        <a
          href={slide.buttonUrl}
          className="btn btn-dark btn-outline btn-icon btn-small"
        ></a>
        <URLInputButton
          url={slide.buttonUrl}
          onChange={(buttonUrl) => updateSlide(index, { buttonUrl })}
        />
      </p>
      <Button
        isSmall
        isPrimary
        onClick={() => removeSlide(index)}
        className="removeStaticButton"
      >
        <Icon icon="no-alt" /> {__('Remove Slide')}
      </Button>
    </div>
  );

  return (
    <Fragment>
      <InspectorControls>
        <PanelBody title={__('Slider Settings')}>
          <Button isPrimary onClick={addSlide}>
            <Icon icon="insert" /> {__('Add Slide')}
          </Button>
          <SelectControl
            label={__('Section Class')}
            value={sectionClass}
            options={[
              { label: 'Dark Primary', value: 'section-dark-primary' },
              { label: 'Dark Secondary', value: 'section-dark-secondary' },
              { label: 'Light Primary', value: 'section-light-primary' },
              { label: 'Light Secondary', value: 'section-light-secondary' },
            ]}
            onChange={(value) => setAttributes({ sectionClass: value })}
          />
          <SelectControl
            label={__('Corner Position')}
            value={cornerPositionClass}
            options={[
              { label: 'None', value: 'corner-disabled' },
              { label: 'Left-Top', value: 'corner-left-top' },
              { label: 'Left-Bottom', value: 'corner-left-bottom' },
              { label: 'Right-Top', value: 'corner-right-top' },
              { label: 'Right-Bottom', value: 'corner-right-bottom' },
            ]}
            onChange={(value) => setAttributes({ cornerPositionClass: value })}
          />
          <SelectControl
            label={__('Corner Background')}
            value={cornerBackgroundClass}
            options={[
              { label: 'Dark Primary', value: 'corner-on-dark-primary' },
              { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
              { label: 'Light Primary', value: 'corner-on-light-primary' },
              { label: 'Light Secondary', value: 'corner-on-light-secondary' },
            ]}
            onChange={(value) =>
              setAttributes({ cornerBackgroundClass: value })
            }
          />
        </PanelBody>
      </InspectorControls>
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${cornerClassMapping[sectionClass]} ${cornerBackgroundClass}`}
        ></div>
        <div className="horizontal-slider-wrapper">
          <div className="slider-container">
            <div className="content-wrapper">
              <RichText
                tagName="h2"
                value={sectionTitle}
                onChange={(title) => setAttributes({ sectionTitle: title })}
                placeholder={__('Customer stories')}
              />
              <div className={'description'}>
                <RichText
                  tagName="p"
                  value={description}
                  onChange={(desc) => setAttributes({ description: desc })}
                  placeholder={__(
                    'Read what our customer has to say about [This product]'
                  )}
                />
              </div>

              <p className="buttons">
                <button
                  title="Prev"
                  data-slider={uniqueSliderId}
                  data-type="prev"
                  className="btn btn-outline btn-light btn-icon"
                ></button>
                <button
                  title="Next"
                  data-slider={uniqueSliderId}
                  data-type="next"
                  className="btn btn-outline btn-light btn-icon"
                ></button>
              </p>
            </div>
            <div className="list-wrapper">
              <div
                className="list"
                data-slider="horizontal-slider"
                id={uniqueSliderId}
              >
                {slides &&
                  slides.length &&
                  slides.map((slide, index) => getSlideContent(slide, index))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

registerBlockType('pg/horizontal-slider', {
  title: 'PG Horizontal Slider',
  icon: 'slides',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    slides: {
      type: 'array',
      default: [],
    },
    uniqueSliderId: {
      type: 'string',
      default: '',
    },
    sectionTitle: {
      type: 'string',
      source: 'html',
      selector: 'h2',
    },
    description: {
      type: 'string',
      source: 'html',
      selector: 'div.description',
    },
    sectionClass: {
      type: 'string',
      default: 'section-dark-secondary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-disabled',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-primary',
    },
  },
  edit: BlockEdit,
  save: ({ attributes }) => {
    const {
      slides,
      uniqueSliderId,
      sectionTitle,
      description,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
    } = attributes;

    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${cornerClassMapping[sectionClass]} ${cornerBackgroundClass}`}
        ></div>
        <div className="horizontal-slider-wrapper">
          <div className="slider-container">
            <div className="content-wrapper">
              <RichText.Content tagName="h2" value={sectionTitle} />
              <div
                className={'description'}
                dangerouslySetInnerHTML={{ __html: description }}
              />
              <p className="buttons">
                <button
                  title="Prev"
                  data-slider={uniqueSliderId}
                  data-type="prev"
                  className="btn btn-outline btn-light btn-icon"
                ></button>
                <button
                  title="Next"
                  data-slider={uniqueSliderId}
                  data-type="next"
                  className="btn btn-outline btn-light btn-icon"
                ></button>
              </p>
            </div>
            <div className="list-wrapper">
              <div
                className="list"
                data-slider="horizontal-slider"
                id={uniqueSliderId}
              >
                {slides &&
                  slides.length &&
                  slides.map((slide, index) => (
                    <div className="product-slide-container" key={index}>
                      <div className="content">
                        <div>
                          <RichText.Content tagName="h2" value={slide.quote} />
                          <div
                            className="description"
                            dangerouslySetInnerHTML={{
                              __html: slide.nameTitle,
                            }}
                          />
                          {slide.logoUrl && (
                            <div className={'logo'}>
                              <img
                                src={slide.logoUrl}
                                alt={slide.logoAlt || 'Logo'} // Use logoAlt in save
                              />
                            </div>
                          )}
                          <div className="buttons">
                            {slide.buttons &&
                              slide.buttons.length &&
                              slide.buttons.map((button, bIndex) => (
                                <a
                                  key={bIndex}
                                  href={button.link}
                                  className={button.buttonClass}
                                >
                                  {button.label}
                                </a>
                              ))}
                          </div>
                        </div>
                        <div>
                          {slide.imgUrl && (
                            <img
                              src={slide.imgUrl}
                              alt={slide.imgAlt || 'Image'} // Use imgAlt in save
                            />
                          )}
                        </div>
                      </div>
                      <p className="button-corner">
                        <a
                          href={slide.buttonUrl}
                          className="btn btn-dark btn-outline btn-icon btn-small"
                        ></a>
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  },
});
